import { CONSTANTS } from '@/types/enum/constants'

const getIsManagerCompany = (loggedUserRoles: string[]): boolean => {
  if (!loggedUserRoles) return false
  return (
    !!loggedUserRoles.find(value =>
      [CONSTANTS.ROLE_DYNAMIC_OWNER_USER_COMPANY].find(role => role === value)
    ) || false
  )
}

export default getIsManagerCompany
